<template>
<div class="top-header">
  <div class="top">
    <div @click="toHome('https://www.mominger.com/')" class="top-logo">
      <div class="mlogo">
        <img src="@/assets/moming-logo.svg"/>
      </div>
      <div class="line"></div>
      <div class="zlogo">
        <img src="@/assets/专精特新.png" alt="">
      </div>
      <div class="text">
        <p>国家级高新技术企业</p>
        <p>专精特新中小企业</p>
      </div>
    </div>

    <div class="menu-container">
      <ul class="main-menu">
        <li v-for="(item, index) in menuItems" :key="index" :class="[{'mactive':(activeIndex == index && isHoverNav) || isHomeNav == index}]" @mouseenter="showSubmenu(index)" @mouseleave="hideSubmenu" @click="handleClick(item.link)">
          {{ item.title }}
        </li>
      </ul>
    </div>
    <div class="vision-link">
      <div class="box" @click="toVision">
        <div>
          <img src="@/assets/visionlogo-normal.svg" alt="" class="img1">
          <img src="@/assets/visionlogo-white.svg" alt="" class="img2">
        </div>
        <span>视觉<br/>商城</span>
      </div>
    </div>
  </div>
  <div :class="['menu-box',{'showBox':isShowMenuBox},menuItemObj.asideList.length ? '' : 'pad']" @mouseenter="showSubmenu(activeIndex)" @mouseleave="hideSubmenu">
    <div class="mb-title" v-show="!menuItemObj.asideList.length">{{ menuItemObj.title }}</div>
    <div class="product-page">
      <!-- 左侧分类导航 -->
      <aside class="sidebar" v-show="menuItemObj.asideList.length">
        <div class="side-title">{{ menuItemObj.title }}</div>
        <nav class="category-nav">
          <ul>
            <li v-for="(side,index) in menuItemObj.asideList" :class="['category-item', {'sideactive':sideIndex === index}]" @click="sideIndex = index">{{side}}</li>
          </ul>
        </nav>
      </aside>

      <!-- 右侧产品内容区 -->
      <main :class="[menuItemObj.asideList.length ? 'content-area-side' : 'content-area']">
        <div class="products-grid">
          <!-- 产品卡片 1 -->
          <div class="product-card" v-for="link in menuItemLinkList" @click="handleClick(link.link, link.type)">
              <h3 class="product-title">{{link.name}}</h3>
              <p class="product-desc">
                {{link.desc}}
              </p>
          </div>
        </div>
      </main>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Top',
  props:['isScrolled'],
  data () {
    return {
      showVisionLogo:false,
      isHighLight: true,
      // 新菜单变量20250213
      activeIndex: null,
      isHoverNav:true,
      isHomeNav:null,
      //侧边栏激活变量
      sideIndex:0,
      menuItems: [
        { title: "首页",
          link: "https://www.mominger.com/",
          asideList:[],
          linkList:[[]] 
        },
        { title: "产品中心", 
          asideList:[],
          linkList:[
            [{name:'MomingVision',desc:'视觉案例商城，让零编辑部署工业视觉',link:'https://mmkj.mominger.com:6443/',type:'vision'},
            {name:'焊接机器人工作站',desc:'焊接机器人同时实时跟踪焊缝、观测效果，为各行业提供智能高效的焊接方案', link:'https://mmkj.mominger.com:8443/product5/product5_17'},
            {name:'喷涂机器人工作站',desc:'喷涂机器人通过3D视觉实时识别，智能规划最优喷涂路径，精准适配复杂曲面及大工件', link:'https://mmkj.mominger.com:8443/product5/product5_18'},
            {name:'抛光打磨机器人工作站',desc:'打磨机器人专为工件的自动化去毛刺、抛光及表面精修而设计', link:'https://mmkj.mominger.com:8443/product5/product5_16'},
            {name:'激光切割工作站',desc:'激光切割机器人精准完成异形管件端口切割及多角度异形开口等高难度作业', link:'https://mmkj.mominger.com:8443/product5/product5_19'},
            {name:'无序抓取机器人工作站',desc:'基于先进的3D视觉定位与深度学习算法，实现复杂工况下的高精度自适应抓取', link:'https://mmkj.mominger.com:8443/product5/product5_21'},
            {name:'搬运码垛机器人工作站',desc:'搬运码垛机器人利用 3D视觉技术，可精准识别并定位货物，实现高效的搬运码垛作业', link:'https://mmkj.mominger.com:8443/product5/product5_20'},]
          ] 
        },
        { title: "解决方案", 
          asideList:[],
          linkList:[
            [{name:'教育行业',desc:'虚拟仿真实验室（示范基地）建设解决方案',link:'https://mmkj.mominger.com:8443/solution/solution1'},
            {name:'制造业',desc:'智能制造解决方案',link:'https://mmkj.mominger.com:8443/solution/solution2'},
            {name:'能源行业',desc:'燃气巡检解决方案',link:'https://mmkj.mominger.com:8443/solution/solution3'},
            {name:'虚拟仿真',desc:'虚拟仿真解决方案',link:'https://mmkj.mominger.com:8443/solution/solution7'},
            {name:'建筑行业',desc:'智慧建筑解决方案',link:'https://mmkj.mominger.com:8443/solution/solution4'},
            {name:'智慧城市',desc:'智慧城市解决方案',link:'https://mmkj.mominger.com:8443/solution/solution5'},
            {name:'交通运输业',desc:'模拟驾驶平台解决方案',link:'https://mmkj.mominger.com:8443/solution/solution6'}]
          ]
        },
        { title: "成功案例", 
          asideList:['虚拟仿真','数字孪生','工业仿真','软件开发','嵌入式','自动化','机械设计','其他'],
          linkList:[
            [
              {name:'大别山红色文化虚拟仿真教学系统',desc:'借助大别山地区丰厚且独特的红色文化资源，聚焦并虚拟再现黄麻起义这一重大历史事件。',link:'https://mmkj.mominger.com:8443/successCase/case1'},
              {name:'国土安全虚拟仿真教学',desc:'国土安全虚拟仿真教学系统通过建立介绍多个不同历史时期的仿真场景。',link:'https://mmkj.mominger.com:8443/successCase/case9'},
              {name:'岩心钻机虚拟仿真教学系统',desc:'岩心钻机虚拟仿真教学系统是一种专为培养用户岩心钻探技术应用能力而设计的虚拟学习工具。',link:'https://mmkj.mominger.com:8443/successCase/case10'},
              {name:'激光破岩虚拟仿真教学系统',desc:'通过激光破岩虚拟仿真教学系统，用户可以体验激光破岩设备的工作过程、操作流程和效果展示。',link:'https://mmkj.mominger.com:8443/successCase/case11'},
              {name:'非开挖钻机虚拟仿真教学系统',desc:'非开挖钻机虚拟仿真教学系统能够全面模拟非开挖钻机的操作以及地下蜿蜒曲折的定向钻进工艺。',link:'https://mmkj.mominger.com:8443/successCase/case12'},
              {name:'珠宝切割加工虚拟仿真系统',desc:'在珠宝切割加工虚拟仿真系统中，通过操作模拟练习、了解掌握珠宝切割加工的相关技能。',link:'https://mmkj.mominger.com:8443/successCase/case13'},
              {name:'VR课件资源库之元宇宙CAVE拆装制作',desc:'依托沉浸式虚拟现实（CAVE）技术，打造沉浸式交互教学平台。',link:'https://mmkj.mominger.com:8443/successCase/case28'}
            ],
            [
              {name:'5000米岩心钻机数字孪生系统',desc:'5000米岩心钻机数字孪生系统是理工科专业学生和工程师学习与实践的重要工具',link:'https://mmkj.mominger.com:8443/successCase/case2'},
              {name:'数字孪生工程监测平台',desc:'数字孪生工程监测平台是一个先进的数字化管理系统',link:'https://mmkj.mominger.com:8443/successCase/case14'},
              {name:'机器人/生产线数字孪生系统',desc:'机器人/生产线数字孪生系统是现代制造技术的一大革新',link:'https://mmkj.mominger.com:8443/successCase/case25'},
              {name:'5G挖机远程控制系统',desc:'5G挖机远程控制系统是基于第五代移动通信技术开发的智能化设备管理平台',link:'https://mmkj.mominger.com:8443/successCase/case29'}
            ],
            [
              {name:'六自由度游乐船',desc:'该装置基于六自由度平台，可以构建120~360度三维视景空间，具有身临其境的船舶操纵环境',link:'https://mmkj.mominger.com:8443/successCase/case3'},
              {name:'赛车驾驶模拟器',desc:'赛车驾驶模拟器巧妙地融合了3D场景建模技术，再现了真实的赛车环境',link:'https://mmkj.mominger.com:8443/successCase/case15'},
              {name:'仿真飞行模拟器',desc:'仿真飞行模拟器可模拟飞行驾驶舱中专业飞行员的驾驶操作，为飞行员的安全学习提供可靠基础',link:'https://mmkj.mominger.com:8443/successCase/case16'}
            ],
            [
              {name:'智能巡检一体化系统',desc:'针对燃气等行业开发的对管道进行巡检的综合管理平台',link:'https://mmkj.mominger.com:8443/successCase/case4'},
              {name:'政务指尖办小程序',desc:'为群众带来更快捷、更高效的全新政务服务体验',link:'https://mmkj.mominger.com:8443/successCase/case17'},
              {name:'高校数字资源管理系统',desc:'针对高校对数字化资源管理与利用的迫切需求，精心开发的高校数字资源管理系统',link:'https://mmkj.mominger.com:8443/successCase/case18'},
              {name:'智慧停车小程序',desc:'一款专注于解决停车难题的便捷工具',linki:'https://mmkj.mominger.com:8443/successCase/case30'},
            ],
            [
              {name:'温度监控仪',desc:'支持多种温度传感器(热电偶、热电阻)同时测试记录',link:'https://mmkj.mominger.com:8443/successCase/case5'},
              {name:'全自动消解仪',desc:'专为实验室设计的先进设备，它彻底改变了传统消解方法所带来的繁琐操作。',link:'https://mmkj.mominger.com:8443/successCase/case19'},
              {name:'六自由度平台',desc:'高度集成式六自由度平台',link:'https://mmkj.mominger.com:8443/successCase/case20'}
            ],
            [
              {name:'装配式建筑墙板安装生产线',desc:'通过3D视觉相机系统定位，采用气动吸盘抓取机构抓取板料',link:'https://mmkj.mominger.com:8443/successCase/case6'},
              {name:'机器人上下料组装工作站',desc:'通过机械臂与机器视觉的协同工作，机器人上下料组装工作站能够实现对物料的精准抓取和组装',link:'https://mmkj.mominger.com:8443/successCase/case21'},
              {name:'复合轻钢龙骨墙板自动化生产线',desc:'一种先进的生产工艺，通过采用智能机器人技术对新型材料进行拼接组装',link:'https://mmkj.mominger.com:8443/successCase/case22'}
            ],
            [
              {name:'一体式复合角度倾斜台',desc:'一种整体式、带复合倾斜角度、可移动的整车淋雨试验装置',link:'https://mmkj.mominger.com:8443/successCase/case7'},
              {name:'定制工装夹具',desc:'根据客户提供的样品需求，进行工装的定制设计',link:'https://mmkj.mominger.com:8443/successCase/case23'},
              {name:'超声波喷涂机',desc:'一种高效、精确和现代化的喷涂设备，专为满足小型至中型规模的工作需求而设计',link:'https://mmkj.mominger.com:8443/successCase/case24'}
            ],
            [
              {name:'AI智能与机器视觉-汽车天窗',desc:'通过对汽车天窗结构件进行扫描，检测工件上铆钉数目及状态是否符合要求',link:'https://mmkj.mominger.com:8443/successCase/case8'},
              {name:'结构仿真',desc:'各类结构仿真项目，致力于提供精准、高效的分析解决方案',link:'https://mmkj.mominger.com:8443/successCase/case26'},
              {name:'安全环保监管数字化',desc:'企业级物联网采集平台集成多类传感器，以全面监测运营状态',link:'https://mmkj.mominger.com:8443/successCase/case27'}
            ],
          ]  
        },
        { title: "服务中心",
          asideList:[],
          linkList:[
            [{name:'资料下载',desc:'试用软件、产品手册、技术白皮书、行业方案等', link:'https://mmkj.mominger.com:8443/download'},
            {name:'视频中心',desc:'产品宣传视频、技术资料视频', link:'https://mmkj.mominger.com:8443/videocenter'},
            {name:'服务保障',desc:'质保政策、技术服务', link:'https://mmkj.mominger.com:8443/servicesupport'},
            {name:'常见问题',desc:'整理产品相关的常见问题', link:'https://mmkj.mominger.com:8443/support'},
            {name:'联系我们',desc:'摩鸣期待与您合作', link:'https://mmkj.mominger.com:8443/contactus'}]
          ]
        },
        { title: "关于摩鸣", 
          asideList:[],
          linkList:[
            [{name:'公司简介',desc:'一家专注于软硬件技术应用研发和信息技术服务的高新技术企业', link:'https://mmkj.mominger.com:8443/about'},
            {name:'新闻动态',desc:'摩鸣科技官方发布的最新动态',link:'https://mmkj.mominger.com:8443/news'},
            {name:'加入摩鸣',desc:'准备好加入摩鸣了吗',link:'https://mmkj.mominger.com:8443/jobs'},]
          ]  
        }
      ],
      isShowMenuBox:false
    }
  },
  watch:{
    isScrolled(nval){
      console.log(nval);
      
      if(!nval) return this.isHighLight = false
      setTimeout(() => {
        this.isHighLight = true
      }, 300);
    }
  },
  computed:{
    menuItemObj(){
      this.sideIndex = 0
      return this.menuItems?.[this.activeIndex || 0] || {title: "",link: "",asideList:[],linkList:[] }
    },
    menuItemLinkList(){
      return this.menuItems?.[this.activeIndex || 0].linkList[this.sideIndex]
    }
  },
  methods: {
    // 新菜单方法20250213
    showSubmenu(index) {
      if(index === 0){
        this.isHomeNav = 0
        this.isShowMenuBox = false
        this.isHoverNav = false
        return 
      } 
      this.isHoverNav = true
      this.activeIndex = index
      this.isShowMenuBox = true
    },
    hideSubmenu() {
      if(this.isHomeNav == 0){
        this.isHomeNav = null
      } 
      this.isHoverNav = false
      this.isShowMenuBox = false

      
    },
    // 路由跳转
    handleClick(link, type) {
      if(type === 'vision'){
        window.open(link, '_blank')
        return
      }
      if(link){
        window.location.href = link;
      }

    },
    // 跳转至案例商城
    toVision(){
      window.open('https://mmkj.mominger.com:6443/', '_blank')
    },
    // 回到首页
    toHome(link){
      if(link){
        window.location.href = link;
      }
    }
  },
}
</script>

<style lang="less" scoped>
.top-header{
  position: relative;
  width: 100%;
  padding: 0 160px;
  background-color: transparent;
  &:hover{
    background-color: #ffffff;
    .top{
      .top-logo{
        .text{
          color: #2c2c2c;
        }
      }
    }
    .vision-link{
      .box{
        color: #2c2c2c;
      }
    }
    .menu-container{
      .main-menu > li{
        color: #2c2c2c;
      }
    }
  }
}
.top {
  height: 100px;
  width: 100%;  
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  z-index: 9;
  .top-logo{
    display: flex;
    width: 480px;
    height: 56px;
    align-items: center;
    cursor: pointer;
    .mlogo{
      flex: 1;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .line{
      width: 3px;
      height: 20px;
      margin: 0 10px;
      background-color: #000000;
    }
    &.hov .line{
      background-color: #ffffff;
    }
    .zlogo{
      margin-right: 14px;
    }
    .text{
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      &>p:last-child{
        letter-spacing: 2.6px;
      }
    }
  }
}
.pad{
  padding: 20px 80px;
}
.menu-box{
  width: calc(100% - 320px);
  // min-height: 460px;
  background-color: #fff;
  position: absolute;
  top: 100%;
  transform: translateY(-30px);
  opacity: 0;
  pointer-events: none;
  transition: transform .4s ease-out,opacity .4s ease-out;
  box-sizing: border-box;
  box-shadow: 1px 1px 1px #ccc;
  // box-shadow: inset 1px 1px 1px #dad9d9;
  border-radius: 0px 0px 20px 20px;
  overflow: hidden;
  .mb-title{
    font-size: 20px;
    color: #414141;
    margin-bottom: 32px;
    font-weight: 600;
    padding-left: 24px;
  }
  .product-page {
    display: flex;
    width: 100%;
    box-sizing: border-box;

    // 左侧边栏样式
    .sidebar {
      width: 280px;
      display: flex;
      flex-direction: column;
      // margin-right: 70px;
      padding: 30px 0;
      background-color: #fcfcfc;
      border-right: 1px solid #f0f0f0;
      .side-title{
        font-size: 20px;
        padding-left: 50px;
        margin-bottom: 20px;
      }

      .category-nav {
        padding: 0;
        ul {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 5px;
        }

        .category-item {
          padding: 8px 0px 8px 50px;
          border-radius: 4px;
          transition: all 0.2s ease;
          position: relative;
          cursor: pointer;
          &:hover{
            color: #4a90e2;
            background: #f0f7ff;
          }
          span{
            &:hover::after{
              width: 100%;
            }
          }

          &.active>span::after {
            width: 100%;
          }
        }
        .category-item.sideactive{
          background-color: #fff;
          color: #4a90e2;
          &::before{
            content: '';
            position: absolute;
            display: block;
            left: 0;
            top: 0;
            width: 4px;
            height: 100%;
            background: #4a90e2;
          }
        }
      }
    }

    // 右侧内容区域样式
    .content-area-side{
      flex: 1;
      padding: 10px 80px;
      .products-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 32px 80px;
      }
    }
    .content-area {
      flex: 1;
      padding: 10px 0px;
      .products-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 32px 80px;
      }
    }
    .product-card {
      cursor: pointer;
      transition: all 0.3s ease;
      padding: 24px;
      box-sizing: border-box;
      border-radius: 12px;
      border: 1px solid transparent;

      .product-title {
        margin: 0 0 16px 0;
        font-size: 15px;
        font-weight: 500;
        color: #414141;
      }

      .product-desc {
        margin: 0;
        font-size: 12px;
        color: #7a7a7a;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      &:hover{
        transform: translateY(-5px);
        box-shadow: 0 6px 12px #dcdde0;
        border-color: #f0f0f0;
        background: #fff;
        .product-title{
          color: #79aff2;
        }
      }
    }
  }

  // 响应式调整
  @media (max-width: 1200px) {
    .product-page {
      .content-area {
        .products-grid {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }
  }

  @media (max-width: 768px) {
    .product-page {
      flex-direction: column;
      
      .sidebar {
        width: 100%;
      }
      
      .content-area {
        .products-grid {
          grid-template-columns: 1fr;
        }
      }
    }
  }
}
.menu-box.showBox{
  pointer-events: auto;
  transform: translateY(0px);
  opacity: 1;
}
// 新菜单样式20250213
.menu-container {
  color: #060606;
  z-index: 99;
  margin-left: 100px;
  height: 100%;
}

.vision-link{
  flex: 1;
  display: flex;
  justify-content: end;
  .box{
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    color: #ffffff;
    padding: 8px;
    border-radius: 10px;
  }
  .img1{
    display: inline;
  }
  .img2{
    display: none;
  }
  &>div.box{
    height: 40px;
    cursor: pointer;
    position: relative;
    &>div{
      height: 100%;
      img{
        width: 100%;
        height: 100%;
      }
    }

  }
  .box:hover{
    background-color: #79AFF2;
    &>span{
      color: #ffffff;
    }
    .img1{
      display: none;
    }
    .img2{
      display: inline;
    }
  }
}

.main-menu {
  min-width: 650px;
  display: flex;
  justify-content: space-between;
  list-style: none;
  padding: 0;
  margin: 0;
  height: 100%;
}

.main-menu > li {
  position: relative;
  cursor: pointer;
  font-size: 15px;
  height: 100%;
  display: flex;
  align-items: center;
  color: #ffffff;
  &::after{
    content: '';
    position: absolute;
    width: 0%;
    height: 3px;
    bottom: 0;
    left: 0;
    transition: width .3s ease-in-out;
    background-color: #5EB4E6;
  }
}

.menu-container .main-menu > li.mactive {
  color: #5EB4E6 !important;
  &::after{
    width: 100%;
  }
}

.submenu {
  position: absolute;
  list-style: none;
  padding: 0;
  margin: 0;
  background: white;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  /* min-width: 200px; */
  /* display: none; */
  border-radius: 10px;
  text-align: center;
  transition: opacity .5s ease-out;
  opacity: 0;
  pointer-events: none;
}

.main-menu > li:hover .submenu {
  /* display: block; */
  pointer-events: auto;
  opacity: 1;
}

.submenu.level-1 {
  top: 100%;
  left: -55%;

  color: #060606; /* 子菜单保持原有颜色 */
}

.submenu.level-1 > li {
  position: relative;
  padding: 10px 20px;
  min-width: max-content;
  transition: all 0.3s ease; /* 添加过渡动画 */
}

.submenu.level-1 > li:hover {
  color: #5EB4E6;
}

.submenu.level-2 {
  top: 0;
  left: 100%;
  display: none !important;
  min-width: 100px;
  color: #060606;
}

.submenu.level-2 > li {
  position: relative;
  padding: 5px 20px;
  transition: all 0.3s ease; /* 添加过渡动画 */
}

.submenu.level-2 > li:hover {
  color: #5EB4E6;
}

.submenu.level-1 > li:hover .submenu.level-2 {
  display: block !important;
}
/* 响应式调整 */
@media (max-width: 1200px) {
  .submenu.level-2 {
    left: auto;
    right: 100%; /* 改为从右侧展开 */
    box-shadow: -2px 2px 5px rgba(0,0,0,0.2); /* 调整阴影方向 */
    margin-right: 2px;
  }

  /* 修正三级菜单位置 */
  // .submenu.level-1 > li:hover .submenu.level-2 {
  //   transform: translateX(-5px);
  // }
}
</style>
